import connectClass from  './connect';
export const connect = connectClass;

export const getDisplayName = WrappedComponent => {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/utils/index.js